import {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import AuthorizationService from '../helpers/AuthorizationService.js';
import { fetchLoggedInUser, fetchDropdownList } from '../api/loginApi.js';
import { useDispatch } from 'react-redux';
import { setUser } from '../authActions.js';
import handle_toast  from '../genericFunctions/toast_Handler.js';

const LoginCallback = ({ userManager }) => {
    const dispatch = useDispatch();    
    const navigate = useNavigate();

    useEffect(() => {
      userManager.signinRedirectCallback().then(async(user) => {
        if(user) {            
          await fetchLoggedInUser().then(async (data) => {
            if(data && data?.data.data[0]){
              dispatch(setUser(user));
              const userDetails = data?.data.data[0];
              sessionStorage.setItem('User', userDetails.name+' - '+userDetails.sesaId)
              sessionStorage.setItem('session', 'active')
              sessionStorage.setItem('userDetails', JSON.stringify(userDetails))
              AuthorizationService.instance = null;
              const authService = AuthorizationService.getInstance();
              await authService.Initialize();
              fetchInitialdata();
              navigate('/products')
            }
            else 
            {
              sessionStorage.setItem('session', 'inactive')
              navigate('/unauthorized')
            }
          })          
        } 
        else {
          sessionStorage.setItem('session', 'inactive')
          navigate('/unauthorized')
        }
      }).catch(() => {
        sessionStorage.setItem('session', 'inactive')
        navigate('/unauthorized')
      });
      
    }, [dispatch, navigate]);

    const fetchInitialdata = async () => {
      try{
          const resp = await fetchDropdownList();
          const formattedDropdownData = resp?.data?.data?.referenceTypeData?.reduce((acc, item) => {
              if(!acc[item.refTypeValue]) acc[item.refTypeValue] = [];
              item.ReferenceValues.map((obj) => {
                  acc[item.refTypeValue].push({name: obj.refValue, id: obj.id, checked: false});
              })
              if(item.ReferenceTypeGroups.length > 0 && !acc[item.ReferenceTypeGroups[0].refTypeGroupCodeValue]) acc[item.ReferenceTypeGroups[0].refTypeGroupCodeValue] = [];
              if(item.ReferenceTypeGroups[0]?.refTypeGroupCodeValue) acc[item.ReferenceTypeGroups[0].refTypeGroupCodeValue].push({name: item.refTypeValue, id: item.refTypeCode, checked: false});
              return acc;
          }, {});
          const productFormat = [];
          resp?.data?.data?.productData?.map((obj) => {
              productFormat.push({name: obj.matterProductId, label: obj.name, category: obj.category, checked: false, team: obj.team}) 
          })
          const userFormat = [];
          resp?.data?.data?.userData?.map((obj) => {
              userFormat.push({name: `${obj.name} - ${obj.email} (${obj.sesaId})`, id: obj.id, sesaId: obj.sesaId, email: obj.email, username: obj.name, checked: false}) 
          })
          const teamFormat = [];
          resp?.data?.data?.teamsData?.map((obj) => {
              teamFormat.push({name: obj.name, id: obj.id, checked: false}) 
          })
          formattedDropdownData['Users'] = userFormat;
          formattedDropdownData['Roles'] = resp?.data?.data?.roleData ? resp?.data?.data?.roleData : [];
          formattedDropdownData['Teams'] = teamFormat;
          formattedDropdownData['ProductList'] = productFormat;
          sessionStorage.setItem('dropDownData', JSON.stringify(formattedDropdownData))
          handle_toast({message: 'Data Fetched', status: 'success'})
  
      }
      catch(error) {
          handle_toast(error)
      }
    }
};

export default LoginCallback;